
export class SubmenuIcon {
    customClass?: string
    disabled?: boolean
    html?: string
    rotate?: boolean = true;
}